import { camelizeKeys } from '~/redux/api/transformers/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { managedEntities } from '~/services/serviceInstances';

import { ListNodesServer } from './types';

interface ListNodesParams {
  resourceType?: 'document' | 'ticket';
  resourceId?: string;
  include?: 'groups';
}

export const listNodes = async (
  { resourceType, resourceId, include }: ListNodesParams,
  options: ServiceRequestConfig = {},
) => {
  const { data, included } = await managedEntities.get<ListNodesServer>(
    `/nodes`,
    {
      params: {
        'filter[resource_type]': resourceType,
        'filter[resource_id]': resourceId,
        include,
      },
      showErrorToast: true,
      ...options,
    },
  );

  return {
    nodes: data.map((node) => camelizeKeys(node)),
    groups: included?.map((group) => camelizeKeys(group)),
  };
};
